/**
 * Peak Priorities participant shell tokens.
 * All structural colors are CSS variable references so they automatically
 * adapt to the app's dark / light theme (toggled via ThemeContext).
 * Brand accent colors (mustard, coral, green, slate) also use CSS vars so
 * they can be tuned per-mode in index.css.
 */
export const C = {
  bg:          'var(--bg)',
  bgRaised:    'var(--bg-raised)',
  surface:     'var(--surface)',
  rule:        'var(--rule)',
  ruleBright:  'var(--rule-bright)',
  slate:       'var(--slate)',
  mustard:     'var(--mustard)',
  coral:       'var(--coral)',
  green:       'var(--green)',
  textPri:     'var(--text-pri)',
  textSec:     'var(--text-sec)',
  textTer:     'var(--text-ter)',
  textDim:     'var(--text-dim)',
  hover:       'var(--hover-tint)',
  activeTint:  'var(--active-tint)',
  activeSlate: 'var(--active-lift)',
} as const;

export const NAV_H = 52;
export const SIDEBAR_W = 240;
